module.exports = __webpack_public_path__ + "img/victron_smart_24_12_20.f6b739a5.png";